import React from 'react';

import { localPreferences } from 'app-components/utils/core';

import { BugsnagErrorBoundary } from 'utils/core/bugsnag';

import FallbackComponent from './FallbackComponent';
import FallbackComponentXS from './FallbackComponentXS';
import LocalErrorBoundary from './LocalErrorBoundary';

type ErrorBoundarySize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

type Props = {
  children?: React.ReactNode;
  size?: ErrorBoundarySize;
  [key: string]: unknown;
};

const ErrorBoundary = ({ children, size, ...otherProps }: Props): React.ReactElement => {
  const disableBugsnag = localPreferences.getDisableBugsnag();
  const ErrorBoundarySelected = disableBugsnag ? LocalErrorBoundary : (BugsnagErrorBoundary ?? LocalErrorBoundary);
  const fallbackComponent = size === 'xs' ? FallbackComponentXS : FallbackComponent;
  return (
    <ErrorBoundarySelected FallbackComponent={fallbackComponent} {...otherProps}>
      {children ?? null}
    </ErrorBoundarySelected>
  );
};

ErrorBoundary.whyDidYouRender = false;

export default ErrorBoundary;
